"use client";

import { Box, Flex } from "@chakra-ui/react";
import NextLink from "next/link";
import { HiOutlineChevronLeft } from "react-icons/hi2";
import { Button } from "@/components";
import { useClassicDashboardStyles } from "@/lib/hooks/useClassicDashboardStyles";
import { useInteractiveTokens, useThemeTokens } from "@/lib/theme/tokens";

export interface SinglePageBackButtonProps {
  href: string;
  label: string;
}

export function SinglePageBackButton({ href, label }: SinglePageBackButtonProps) {
  const theme = useThemeTokens();
  const interactive = useInteractiveTokens();
  const { controlBorderRadius, backdropBlur } = useClassicDashboardStyles();

  return (
    <NextLink href={href}>
      <Flex align="center" gap={2} sx={{
      "@media (hover: hover)": {
        "&:hover": {
          textDecoration: "underline",
        },
      },
    }}>
        <HiOutlineChevronLeft size={16} />
        <Box as="span" display={{ base: "none", sm: "inline" }}>
          {label}
        </Box>
        <Box as="span" display={{ base: "inline", sm: "none" }}>
          Back
        </Box>
        </Flex>
    </NextLink>
  );
}
